CCL.countryRegionMapping = CCL.countryRegionMapping || {};
CCL.checkoutPaymentCard = {
  /* eslint-disable */

  autoload: [
    ['giftCardToggle', $('.toggle-btn').length > 0],
    ['initiateOnboardCredit', $('.onboard-credit').length > 0],
    ['addValidations', $('.payment-card-body').length > 0],
    ['shiftingWatermark', $('.payment-card-body').length > 0],
    ['validateCardDetails', $('.payment-card-body').length > 0],
    ['placeOrder', $('.payment-card-body').length > 0],
    ['checkInfo', $('.payment-card-body').length > 0],
    ['validateYtd', $('.zeroAmountPlaceOrder').length > 0],
  ],

  expiry: false,
  creditChange: false,
  placeOrderDisable: false,
  reg: /^[0-9\\/]*$/, // regex to accept only numbers
  alphaNumReg: /^[- a-zA-Z0-9]{1,10}$/, //regex to accept both numbers, alphabets, space and -
  alphaReg: /^[a-zA-Z\s]*$/, // regex to accept only alphabets and space
  emailReg: /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/, // regex to accept email
  phoneReg: /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/, // regex for phone number

  initiateOnboardCredit() {
    $('body').on('keydown', '.tooltip-onboard-credit', (e) => {
      if (Number(e.which) === 9 && !event.shiftKey && !(event.shiftKey && event.keyCode == 9)) {
        e.preventDefault();
        $('.tooltip-onboard-credit .tooltip_text').toggleClass('open')
        $('.tooltip-onboard-credit a').focus();
      }
    });
  },

  validateYtd() {
    this.validateYtdInputs();
    $('#billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('blur, keyup', (event) => {
      this.validateYtdInputs();
    });

    $('.zeroAmountPlaceOrder').click((e) => {
      $("#silentOrderPostForm").submit();
    });
  },

  validateYtdInputs() {
    const email = $('#billTo_email').val();
    const fname = $('#billTo_firstName').val();
    const lname = $('#billTo_lastName').val();
    const phoneNo = $('#billTo_phoneNumberFormator').val();
    if (email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
      $('.zeroAmountPlaceOrder').removeAttr('disabled');
    } else {
      $('.zeroAmountPlaceOrder').attr('disabled', 'disabled');
    }
  },

  giftCardToggle() {
    $('.toggle-btn').each((index, element) => {
      $(element).click((event) => {
        event.preventDefault();
        $(element).toggleClass('open');
        $('.gift-card-balance .error-msg').remove();
      });
    });

    $('.collapse-header').find('.toggle-btn').on('click', (e) => {
      CCL.checkoutPaymentCard.addCountryRegionData();
      if (e.currentTarget.getAttribute('aria-expanded') !== "false") {
        $('.gift-card-address').addClass('d-none');
      } else {
        $('.gift-card-address').removeClass('d-none');
      }
    });
  },

  addCountryRegionData() {
    if ($.isEmptyObject(CCL.countryRegionMapping)) {
      $.ajax({
        type: "GET",
        url: "/shop/checkout/multi/payment-method/country-region",
        dataType: "json",
        success: function (data) {
          CCL.countryRegionMapping = data;
          CCL.checkoutPaymentCard.addCountries();
        }
      });
    }
    else {
      CCL.checkoutPaymentCard.addCountries();
    }
  },

  addCountries() {
    $.each(CCL.countryRegionMapping, function (index, countryData) {
      $('#gc-country').append('<option value="' + countryData["countryCode"] + '">' + countryData["countryName"] + '</option>');
    });
  },

  addValidations() {
    $(document).ready(function () {
      const appliedGiftcards = $('.add-gift-card');
      if (appliedGiftcards.length) {
        CCL.checkoutPaymentCard.addCountryRegionData();
      }
    });

    $(document).on('change', '#gc-country', (e) => {
      $('#gc-state').empty();
      $('#gc-state').parent().css('display', 'inline-block');
      var countryCode = $('#gc-country').val();
      if (!CCL.countryRegionMapping || !countryCode) return;

      $.each(CCL.countryRegionMapping, function (index, country) {

        if (country["countryCode"] === countryCode) {
          if ($.isEmptyObject(country["regions"])) {
            $('#gc-state').append('<option value="XX">Others</option>');
            $('#gc-state').val('XX');
            $('#gc-state').parent().css('display', 'none');
          }
          else {
            $.each(country["regions"], function (index, region) {
              $('#gc-state').append('<option value="' + region["regionCode"] + '">' + region["regionName"] + '</option>');
            });
          }
          return false;
        }
      });


      $('#gc-state').siblings(".floating-label").addClass('selectFocus');
      $('#gc-state').siblings(".floating-label").addClass('inputFocus');
      $('#gc-state').siblings(".floating-label").removeClass('inputBlur');

      //validation to disable place
      const inputValue = $('#gc-country').val();
      CCL.checkoutPaymentCard.inputEmptyAddressValidation(inputValue, e);
    });
    $('#billTo_firstName').attr('maxlength', '20');
    $('#billTo_lastName').attr('maxlength', '20');
    $('#billTo_phoneNumber').attr('maxlength', '10');
    $('#billTo_phoneNumberFormator').attr('maxlength', '14');
    $('.apply-total').prop('disabled', true);
    $('.gift-card-balance .btn-link').addClass('disable-link');
    $(document).ready(() => {
      $('.gw-proxy-number').attr('title', 'Card Number'); // Adding title to iframe
    });

    let phoneNumberValue = $('#billTo_phoneNumberFormator').val();
    if (phoneNumberValue && phoneNumberValue.length === 10) {
      phoneNumberValue = '(' + phoneNumberValue.slice(0, 3) + ') ' + phoneNumberValue.slice(3, 6) + '-'.concat(phoneNumberValue.slice(6));
      $('#billTo_phoneNumberFormator').val(phoneNumberValue);
    }

    $('#billTo_phoneNumberFormator').on('change', (e) => {
      let phoneNumberValue = $('#billTo_phoneNumberFormator').val();
      let tempNumberValue = phoneNumberValue.replace(/[^0-9]/g, "");
      if (phoneNumberValue) {
        phoneNumberValue = '(' + tempNumberValue.slice(0, 3) + ') ' + tempNumberValue.slice(3, 6) + '-'.concat(tempNumberValue.slice(6));
        $('#billTo_phoneNumberFormator').val(phoneNumberValue);
      }
    });

    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #cardNumber, #pinNumber, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('blur', (e) => {
      const inputValue = $(`#${e.currentTarget.id}`).val();
      this.inputEmptyValidation(inputValue, e);
      if (inputValue.length !== 0) {
        this.inputLengthValidation(inputValue, e);
      }

      if (e.currentTarget.id === 'card_expiryInfo' && !inputValue) {
        $(`#${e.currentTarget.id}`).parent().find('.floating-label').text('MM/YYYY');
      }
    });

    $('#card_expiryInfo').on('focus', (e) => {
      $(`#${e.currentTarget.id}`).parent().find('.floating-label').text('Expiration Date');
    });

    $('#gc-address, #gc-city, #gc-zip, #gc-country, #gc-state').on('blur', (e) => {
      const inputValue = $(`#${e.currentTarget.id}`).val();
      this.inputEmptyAddressValidation(inputValue, e);
      const orderValue = $('.order-summary-total').text();

      if (orderValue.toString() !== 'orderGCFulfilled') {
        this.inputLengthValidation(inputValue, e);
      }
    });

    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator, #cardNumber, #pinNumber, #gc-address, #gc-city, #gc-zip').on('blur', (e) => {
      if (e.currentTarget.parentElement.lastElementChild.style.cssText.split(' ')[1] === 'visible;') {
        let tempErVal = e.currentTarget.parentElement.lastElementChild.textContent;
        let tempAriaVal = $(`#${e.currentTarget.id}`).attr('aria-label');
        if (!tempAriaVal.includes(tempErVal)) {
          $(`#${e.currentTarget.id}`).attr('aria-label', `${tempAriaVal} ${tempErVal}`);
        }
        e.currentTarget.parentElement.lastElementChild.removeAttribute('aria-live');
        e.currentTarget.parentElement.lastElementChild.removeAttribute('role');
      } else {
        if (!e.currentTarget.parentElement.lastElementChild.hasAttribute('aria-live')) {  // if errors are already removed
          let ariaValueInput = $(`#${e.currentTarget.id}`).attr('aria-label');
          if (e.currentTarget.id != 'card_cvNumber' && e.currentTarget.id != 'pinNumber' && e.currentTarget.id != 'billTo_email' && e.currentTarget.id != 'gc-address' && e.currentTarget.id != 'gc-city' && e.currentTarget.id != 'gc-zip' && e.currentTarget.id != 'cardNumber') {
            let mainInputAriaValue = ariaValueInput.split(' ');
            const newAriaLabelValue = mainInputAriaValue[0] + ' ' + mainInputAriaValue[1];
            $(`#${e.currentTarget.id}`).attr('aria-label', `${newAriaLabelValue}`);
            e.currentTarget.parentElement.lastElementChild.setAttribute('aria-live', 'assertive');
            e.currentTarget.parentElement.lastElementChild.setAttribute('role', 'alert');
          } else if (e.currentTarget.id === 'cardNumber') {
            let mainInputAriaValue = ariaValueInput.split(' ');
            const newAriaLabelValue = mainInputAriaValue[0] + ' ' + mainInputAriaValue[1] + ' ' + mainInputAriaValue[1];
            $(`#${e.currentTarget.id}`).attr('aria-label', `${newAriaLabelValue}`);
            e.currentTarget.parentElement.lastElementChild.setAttribute('aria-live', 'assertive');
            e.currentTarget.parentElement.lastElementChild.setAttribute('role', 'alert');
          } else {
            let mainInputAriaValue = ariaValueInput.split(' ');
            const newAriaLabelValue = mainInputAriaValue[0];
            $(`#${e.currentTarget.id}`).attr('aria-label', `${newAriaLabelValue}`);
            e.currentTarget.parentElement.lastElementChild.setAttribute('aria-live', 'assertive');
            e.currentTarget.parentElement.lastElementChild.setAttribute('role', 'alert');
          }
        }
      }
    });

    $("#billTo_phoneNumberFormator").on("paste", function (e) {
      setTimeout(function () {
        let inputValue = $(`#${e.currentTarget.id}`).val();
        if (inputValue.length === 10) {
          inputValue = '(' + inputValue.slice(0, 3) + ') ' + inputValue.slice(3, 6) + '-'.concat(inputValue.slice(6));
          $(`#${e.currentTarget.id}`).val(inputValue);
        }
      }, 1);
    });

    // Disabling place order if the field is not correct
    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #cardNumber, #pinNumber, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('keyup', (e) => {
      let inputValue = $(`#${e.currentTarget.id}`).val();
      this.inputEmptyValidation(inputValue, e);
      this.inputValidation(inputValue, e);

      if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 9) {
        if (e.which === 8) {
          inputValue = inputValue.substr(0, 8);
          $(`#${e.currentTarget.id}`).val(inputValue);
        }
      } else if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 5) {
        if (e.which === 8) {
          inputValue = inputValue.substr(1, 2);
          $(`#${e.currentTarget.id}`).val(inputValue);
        }
      }

      if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 3 && inputValue[0] != '(') {
        inputValue = '(' + inputValue + ') ';
        $(`#${e.currentTarget.id}`).val(inputValue);
      } else if (e.currentTarget.id === 'billTo_phoneNumberFormator' && inputValue.length === 9) {
        inputValue = inputValue + '-';
        $(`#${e.currentTarget.id}`).val(inputValue);
      }
      if (e.currentTarget.id === 'cardNumber') {
        if (!inputValue.match(/^\d+$/) || (inputValue.length > 16 || inputValue.length < 6) || ($('#pinNumber').val().length < 4 || $('#pinNumber').val().length > 4)) {
          $('.apply-total').prop('disabled', true);
          $('.gift-card-balance .btn-link').addClass('disable-link');
          e.currentTarget.parentElement.lastElementChild.textContent = `Should be 6-16 digits`;
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else {
          $('.gift-card-balance .btn-link').removeClass('disable-link');
          $('.apply-total').prop('disabled', false);
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
        }
      }

      if (e.currentTarget.id === 'pinNumber') {
        if (!inputValue.match(/^\d+$/) || (inputValue.length < 4 || inputValue.length > 4) || !$('#cardNumber').val().length || !$('#cardNumber').val().match(/^\d+$/) || ($('#cardNumber').val().length > 16 || $('#cardNumber').val().length < 6)) {
          $('.gift-card-balance .btn-link').addClass('disable-link');
          $('.apply-total').prop('disabled', true);
          e.currentTarget.parentElement.lastElementChild.textContent = `Should be 4 digits`;
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else {
          $('.gift-card-balance .btn-link').removeClass('disable-link');
          $('.apply-total').prop('disabled', false);
          e.currentTarget.parentElement.lastElementChild.textContent = 'Should be 4 digits';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
        }
      }

    });

    $('#gc-address, #gc-city, #gc-zip, #gc-country, #gc-state').on('keyup', (e) => {
      const inputValue = $(`#${e.currentTarget.id}`).val();
      this.inputEmptyAddressValidation(inputValue, e);
    });

    // Displaying error if the field contains text
    $('#card_cvNumber, #billTo_postalCode, #card_expiryInfo, #cardNumber, #pinNumber, #billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('keyup', (e) => {
      const inputValue = $(`#${e.currentTarget.id}`).val();
      this.inputEmptyValidation(inputValue, e);
      if (e.currentTarget.id === 'card_expiryInfo') {
        if (inputValue.length === 2) {
          if (inputValue > 0 && inputValue <= 12) {
            $('#card_expiryInfo').val(`${inputValue}/`);
            e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
            this.expiry = false;
          } else {
            this.expiry = true;
            e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Month';
            e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
          }
        }

        if (!this.expiry || inputValue.length === 0) {
          this.inputValidation(inputValue, e);
        }
      } else {
        this.inputValidation(inputValue, e);
      }
    });

    $('#gc-address, #gc-city, #gc-zip').on('keyup', (e) => {
      const inputValue = $(`#${e.currentTarget.id}`).val();
      if (e.currentTarget.id === 'gc-address') {
        $('#gc_form_street').val(inputValue)
      } else if (e.currentTarget.id === 'gc-city') {
        $('#gc_form_city').val(inputValue)
      } else if (e.currentTarget.id === 'gc-zip') {
        $('#gc_form_zipcode').val(inputValue)
      }

      this.inputAddressValidation(inputValue, e);
    });
  },

  inputAddressValidation(inputValue, e) {
    if (e.currentTarget.id === 'gc-address') {
      const regExPattern = /^[a-zA-Z0-9\-, ]+$/;
      if (!regExPattern.test(inputValue)) {
        e.currentTarget.parentElement.lastElementChild.textContent = `Invalid Address`;
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        $('.placeOrder').attr('disabled', 'disabled');
      } else {
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      }
    } else if (!this.alphaNumReg.test(inputValue) && e.currentTarget.id === 'gc-zip') {
      e.currentTarget.parentElement.lastElementChild.textContent = 'Only Numerics Allowed';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    }
    else if (!this.alphaReg.test(inputValue) && e.currentTarget.id === 'gc-city') {
      if (inputValue.length !== 0) {

        e.currentTarget.parentElement.lastElementChild.textContent = 'Only Alphabets Allowed';
      }
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    }
    else {
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
    }
  },

  inputValidation(inputValue, e) {
    if (!this.emailReg.test(inputValue) && e.currentTarget.id === 'billTo_email') {
      if (inputValue.length !== 0) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Incorrect Email';
      }
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    }
    else if (!this.alphaReg.test(inputValue) && (e.currentTarget.id === 'billTo_firstName' || e.currentTarget.id === 'billTo_lastName')) {
      if (inputValue.length !== 0) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Only Alphabets Allowed';
      }
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else if (!this.phoneReg.test(inputValue) && e.currentTarget.id === 'billTo_phoneNumberFormator') {
      if (inputValue.length !== 0) {
        e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Phone Number';
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      }
      $('.placeOrder').attr('disabled', 'disabled');
    } else if (this.phoneReg.test(inputValue) && e.currentTarget.id === 'billTo_phoneNumberFormator') {
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      const unformatedNumber = inputValue.replace(/[^0-9]/g, "").slice(0, 10);
      $('#billTo_phoneNumber').val(unformatedNumber); // Form element which is in hidden state, when we click place order form will pick ph no from this
    } else if (!this.reg.test(inputValue) && e.currentTarget.id !== 'billTo_firstName' && e.currentTarget.id !== 'billTo_lastName' && e.currentTarget.id !== 'billTo_email' && e.currentTarget.id !== 'billTo_phoneNumberFormator' && e.currentTarget.id !== 'billTo_postalCode') {
      e.currentTarget.parentElement.lastElementChild.textContent = 'Only Numerics Allowed';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      $('.placeOrder').attr('disabled', 'disabled');
    } else {
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      if (e.currentTarget.id === 'card_expiryInfo' && inputValue.length === 7) {
        const currentDate = new Date();
        const dateFormat = inputValue.split('/');
        if (Number(dateFormat[0]) > 12) {
          e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Month';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
          $('.placeOrder').attr('disabled', 'disabled');
        } else if (Number(dateFormat[1]) < Number(currentDate.getFullYear()) || Number(dateFormat[1] > 2100)) {
          e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Year';
          e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
          $('.placeOrder').attr('disabled', 'disabled');
        } else if (Number(dateFormat[1]) === Number(currentDate.getFullYear())) {
          if (Number(dateFormat[0]) < Number(currentDate.getMonth()) + 1) {
            e.currentTarget.parentElement.lastElementChild.textContent = 'Invalid Month';
            e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
            $('.placeOrder').attr('disabled', 'disabled');
          } else {
            $('#card_expirationMonth').val(dateFormat[0]);
            $('#card_expirationYear').val(dateFormat[1]);
          }
        } else {
          $('#card_expirationMonth').val(dateFormat[0]);
          $('#card_expirationYear').val(dateFormat[1]);
        }
      }
    }
  },

  inputEmptyValidation(inputValue, e) {
    if (inputValue.length === 0) {
      // e.currentTarget.parentElement.lastElementChild.textContent = 'It is a required field';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
    }
    this.disablingPlaceOrder();
  },

  inputEmptyAddressValidation(inputValue, e) {
    if (inputValue.length === 0) {
      // e.currentTarget.parentElement.lastElementChild.textContent = 'It is a required field';
      e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
    }
    this.disablingAdressPlaceOrder();
  },

  inputLengthValidation(inputValue, e) {
    if (e.currentTarget.parentElement.lastElementChild.style.cssText.split(' ')[1] != 'visible;') {
      if (inputValue.length < 7 && e.currentTarget.id === 'card_expiryInfo') {
        e.currentTarget.parentElement.lastElementChild.textContent = `Should be MM/YYYY`;
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      } else if (inputValue.length < 3 && e.currentTarget.id === 'card_cvNumber') {
        e.currentTarget.parentElement.lastElementChild.textContent = `Should be 3 or 4 digits`;
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      } else if (inputValue.length !== 4 && e.currentTarget.id === 'pinNumber') {
        e.currentTarget.parentElement.lastElementChild.textContent = `Should be 4 digits`;
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      } else if ((inputValue.length > 16 || inputValue.length < 6) && e.currentTarget.id === 'cardNumber') {
        e.currentTarget.parentElement.lastElementChild.textContent = `Should be 6-16 digits`;
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:visible';
      }
    }
  },

  disablingPlaceOrder() {
    let iLength = false;
    $('.payment-card .user-input-wrp').find('input').each((index, e) => {
      if (e.value.length === 0 && e.id !== 'card_accountNumber') {
        iLength = true;
      } else {
        if (e.value.length < 7 && e.id === 'card_expiryInfo') {
          iLength = true;
        }
        else if (e.value.length === 7 && e.id === 'card_expiryInfo') {
          const dateField = e.value.split('/');
          for (let i = 0; i < dateField.length; i++) {
            if (!this.reg.test(dateField[i])) {
              iLength = true;
            }
          }
        }
        else if ((e.value.length < 3 || !this.reg.test(e.value)) && e.id === 'card_cvNumber') {
          iLength = true;
        } else if ((e.value.length == 0 || !this.alphaNumReg.test(e.value)) && e.id === 'billTo_postalCode') {
          iLength = true;
        } else if ((e.value.length == 0 || !this.phoneReg.test(e.value)) && e.id === 'billTo_phoneNumberFormator') {
          iLength = true;
        } else if (!this.emailReg.test(e.value) && e.id === 'billTo_email') {
          iLength = true;
        } else if ((e.value.length == 0 || !this.alphaReg.test(e.value)) && e.id === 'billTo_firstName') {
          iLength = true;
        } else if ((e.value.length == 0 || !this.alphaReg.test(e.value)) && e.id === 'billTo_lastName') {
          iLength = true;
        }
        $('.gift-card-address').find('input').each((index, e) => {
          const regExPattern = /^[a-zA-Z0-9\-, ]+$/;
          if ((e.value.length !== 0 && !regExPattern.test(e.value)) && e.id === 'gc-address') {
            iLength = true;
          }
        });

        $('.card-div').find('input').each((index, e) => {
          if (e.value.length === 7 && e.id === 'card_expiryInfo') {
            const val = e.value.split('/');
            if (Number(val[0]) > 12 || Number(val[1]) > 2100) {
              iLength = true
            }
          }
        });

      }
    });

    if (iLength) {
      $('.placeOrder').attr('disabled', 'disabled');
      const orderValue = $('.order-summary-total').text();
      const email = $('#billTo_email').val();
      const fname = $('#billTo_firstName').val();
      const lname = $('#billTo_lastName').val();
      const phoneNo = $('#billTo_phoneNumberFormator').val();
      if ((orderValue.toString() === 'orderGCFulfilled' || $('.order-summary-total')[0].dataset.obc === 'OBC') && email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
        $('.placeOrder').removeAttr('disabled');
      }
    } else {
      const appliedGiftcards = $('.add-gift-card');
      if (appliedGiftcards.length && !this.placeOrderDisable) {
        this.disablingAdressPlaceOrder();
      } else {
        $('.placeOrder').removeAttr('disabled');
      }
    }
  },

  disablingAdressPlaceOrder() {
    let iLength = false;
    const orderValue = $('.order-summary-total').text();
    $('.gift-card-address').find('input, select').each((index, e) => {
      if ((e.value.length === 0 || !this.alphaReg.test(e.value)) && e.id === 'gc-city') {
        iLength = true;
      } else if ((e.value.length === 0 || !this.alphaNumReg.test(e.value)) && e.id === 'gc-zip') {
        iLength = true;
      } else if (e.value.length === 0 && e.id === 'gc-zip') {
        iLength = true;
      } else if (e.value.length === 0 && (e.id === 'gc-country' || e.id === 'gc-state')) {
        iLength = true;
      }
      else if (e.value.length === 0) {
        iLength = true;
      }
    });

    if (iLength) {
      $('.gift-card-address .gift-card-title .error-message').css('display', 'inline-block');
      $('.placeOrder').attr('disabled', 'disabled');
    } else {
      $('.gift-card-address .gift-card-title .error-message').css('display', 'none');
      const orderValue = $('.order-summary-total').text();
      const email = $('#billTo_email').val();
      const fname = $('#billTo_firstName').val();
      const lname = $('#billTo_lastName').val();
      const phoneNo = $('#billTo_phoneNumberFormator').val();
      if ((orderValue.toString() === 'orderGCFulfilled' || $('.order-summary-total')[0].dataset.obc === 'OBC') && email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
        $('.placeOrder').removeAttr('disabled');
      } else {
        this.placeOrderDisable = true;
        this.disablingPlaceOrder();
      }
    }
  },

  shiftingWatermark() {
    $('.payment-card-body .user-input-wrp, .apply-promo .user-input-wrp, .gift-card-body .user-input-wrp').find('input').each((index, e) => {
      const $targetElement = $(`#${e.id}`).parent().find('.floating-label');
      if (!e.value.length) {
        e.nextElementSibling.classList.add('inputBlur');
        e.nextElementSibling.classList.remove('inputFocus');
        if (e.id === 'card_expiryInfo') {
          $targetElement.attr('style', 'top:5px !important');
        } else if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:12px !important');
        }
      } else {
        e.nextElementSibling.classList.add('inputFocus');
        e.nextElementSibling.classList.remove('inputBlur');
        if (e.id === 'card_expiryInfo') {
          $targetElement.attr('style', 'top:-14px !important');
        } else if (e.id === 'promo-id') {
          $targetElement.attr('style', 'top:-4px !important');
        }
      }

      if (e.value.length) {
        if (!this.alphaReg.test(e.value) && (e.id === 'billTo_firstName' || e.id === 'billTo_lastName')) {
          e.parentElement.lastElementChild.textContent = 'Only Alphabets Allowed';
          e.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else if (!this.phoneReg.test(e.value) && e.id === 'billTo_phoneNumberFormator') {
          e.parentElement.lastElementChild.textContent = 'Invalid Phone Number';
          e.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        } else if (!this.emailReg.test(e.value) && e.id === 'billTo_email') {
          e.parentElement.lastElementChild.textContent = 'Incorrect Email';
          e.parentElement.lastElementChild.style.cssText = 'visibility:visible';
        }
      }
    });

    $('.gift-card-body .user-input-wrp').find('select').each((index, e) => {
      const $targetElement = $(`#${e.id}`).parent().find('.floating-label');
      if (!e.value.length) {
        e.nextElementSibling.classList.add('inputBlur', 'selectBlur');
        e.nextElementSibling.classList.remove('inputFocus', 'selectFocus');
      } else {
        e.nextElementSibling.classList.add('inputBlur', 'selectBlur');
        e.nextElementSibling.classList.remove('inputFocus', 'selectFocus');
        $targetElement.attr('style', 'top:13px !important');
      }
    });

    $('.payment-card-body .user-input-wrp, .apply-promo .user-input-wrp, .gift-card-body .user-input-wrp').find('input').on('focusout', (e) => {
      const $targetElement = $(`#${e.currentTarget.id}`).parent().find('.floating-label');
      if (!e.currentTarget.value.length) {
        e.currentTarget.nextElementSibling.classList.add('inputBlur');
        e.currentTarget.nextElementSibling.classList.remove('inputFocus');
        if (e.currentTarget.id === 'card_expiryInfo') {
          $targetElement.attr('style', 'top:5px !important');
        } else if (e.currentTarget.id === 'promo-id') {
          $targetElement.attr('style', 'top:12px !important');
        }
      }
    });

    $('.gift-card-body .user-input-wrp').find('select').on('focusout', (e) => {
      const $targetElement = $(`#${e.currentTarget.id}`).parent().find('.floating-label');
      if (!e.currentTarget.value.length) {
        this.inputEmptyAddressValidation(e.currentTarget.value, e);
        e.currentTarget.nextElementSibling.classList.add('inputBlur', 'selectBlur');
        e.currentTarget.nextElementSibling.classList.remove('inputFocus', 'selectFocus');
      } else {
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      }
    });

    $('.payment-card-body .user-input-wrp, .apply-promo .user-input-wrp, .gift-card-body .user-input-wrp').find('input').on('focus', (e) => {
      const $targetElement = $(`#${e.currentTarget.id}`).parent().find('.floating-label');
      e.currentTarget.nextElementSibling.classList.add('inputFocus');
      e.currentTarget.nextElementSibling.classList.remove('inputBlur');
      if (e.currentTarget.id === 'card_expiryInfo') {
        $targetElement.attr('style', 'top:-14px !important');
      } else if (e.currentTarget.id === 'promo-id') {
        $targetElement.attr('style', 'top:-4px !important');
      }
    });

    $('.gift-card-body .user-input-wrp').find('select').on('change', (e) => {
      if (!e.currentTarget.value.length) {
        this.inputEmptyAddressValidation(e.currentTarget.value, e);
      } else {
        e.currentTarget.parentElement.lastElementChild.style.cssText = 'visibility:hidden';
      }
    });
    $('.gift-card-body .user-input-wrp').find('select').on('focus', (e) => {
      const $targetElement = $(`#${e.currentTarget.id}`).parent().find('.floating-label');
      e.currentTarget.nextElementSibling.classList.add('inputFocus', 'selectFocus');
      e.currentTarget.nextElementSibling.classList.remove('inputBlur', 'selectBlur');
    });
  },

  placeOrder(e) {
    // After complete page load
    window.onload = () => {
      $('.c-checkout-payment-card .error-message').removeAttr('aria-live');
      $('.c-checkout-payment-card .error-message').removeAttr('role');
      setTimeout(() => {
        $('.c-checkout-payment-card .error-message').attr('aria-live', 'assertive');
        $('.c-checkout-payment-card .error-message').attr('role', 'alert');
      }, 3500);
    };

    $('.placeOrder, .placeOrderCartSummary').click((e) => {
      const orderValue = $('.order-summary-total').text();
      const stateValue = $('#gc-state').val();
      const countryValue = $('#gc-country').val();
      const appliedGiftcards = $('.add-gift-card');
      if ((orderValue.toString() === 'orderGCFulfilled' && appliedGiftcards.length) || ($('.order-summary-total').length && $('.order-summary-total')[0].dataset.obc === 'OBC')) {
        $('#gc_form_state').val(stateValue);
        $('#gc_form_country').val(countryValue);

        $("#silentOrderPostForm").submit();
      } else {
        $('#gc_form_state').val(stateValue);
        $('#gc_form_country').val(countryValue);
        this.pay(e)
      }
    });
  },


  validateCardDetails() {
    var self = this;
    PaymentSession
      .configure({

        fields: {
          // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
          card: {
            number: "#card_accountNumber"
          }
        },
        //SPECIFY YOUR MITIGATION OPTION HERE
        frameEmbeddingMitigation: ["javascript"],
        callbacks: {
          initialized: function (response) {
            // HANDLE INITIALIZATION RESPONSE
          },
          formSessionUpdate: function (response) {
            // console.log(response);
            // HANDLE RESPONSE FOR UPDATE SESSION
            if (response.status) {
              if ("fields_in_error" == response.status) {
                console.log("Session update failed with field errors.");
                if (response.errors.cardNumber) {
                  const $cardElement = $('#card_accountNumber').siblings(".inputErrorField");
                  $cardElement.attr('role', 'alert');
                  $cardElement.attr('aria-live', 'assertive');
                  $cardElement.text('Card Number invalid or missing');
                  $cardElement.attr('style', 'visibility:visible');
                  console.log("Card number invalid or missing.");
                  setTimeout(function () {
                    PaymentSession.setFocus('card.number');
                  }, 3000);

                }
              } else if ("request_timeout" == response.status) {
                console.log("Session update failed with request timeout: " + response.errors.message);
              } else if ("system_error" == response.status) {
                console.log("Session update failed with system error: " + response.errors.message);
              } else if (response.status) {
                console.log(response);
                document.getElementById("tokenRes").value = JSON.stringify(response);
                $("#silentOrderPostForm").submit();
                console.log("Session updated with data: " + response.session.id);

                //check if the security code was provided by the user
                if (response.sourceOfFunds.provided.card.securityCode) {
                  console.log("Security code was provided.");
                }

                //check if the user entered a Mastercard credit card
                if (response.sourceOfFunds.provided.card.scheme == 'MASTERCARD') {
                  console.log("The user entered a Mastercard credit card.")
                }
              }
            } else {
              console.log("Session update failed: " + response);
            }
          }
        }
      });
    PaymentSession.onFocus(['card.number'], function (selector) {
      //handle focus event
      $(selector).css({
        'border': 'rgb(0, 181, 203) solid 3px'
      });
      $(selector).siblings('.floating-label').addClass('inputFocus');
      $(selector).siblings('.floating-label').removeClass('inputBlur');
    });

    PaymentSession.onChange(['card.number'], function (selector) {
      // console.log([PaymentSession]);
      self.creditChange = false;
    });

    PaymentSession.onBlur(['card.number'], function (selector) {
      //handle blur event
      $(selector).css({
        'border': 'none',
        'border-bottom': '1px solid #595959'
      });
      if (self.creditChange) {
        $(selector).siblings('.floating-label').addClass('inputBlur');
        $(selector).siblings('.floating-label').removeClass('inputFocus');
      }
    });
  },

  pay(event) {
    event.preventDefault();
    // UPDATE THE SESSION WITH THE INPUT FROM HOSTED FIELDS
    PaymentSession.updateSessionFromForm('card');
  },

  checkInfo() {
    $('#billTo_firstName, #billTo_lastName, #billTo_email, #billTo_phoneNumberFormator').on('blur, keyup', (e) => {
      const orderValue = $('.order-summary-total').text();
      const email = $('#billTo_email').val();
      const fname = $('#billTo_firstName').val();
      const lname = $('#billTo_lastName').val();
      const phoneNo = $('#billTo_phoneNumberFormator').val();
      if ((orderValue.toString() === 'orderGCFulfilled' || $('.order-summary-total')[0].dataset.obc === 'OBC') && email.length && this.emailReg.test(email) && fname.length && this.alphaReg.test(fname) && lname.length && this.alphaReg.test(lname) && phoneNo.length && this.phoneReg.test(phoneNo)) {
        $('.placeOrder').removeAttr('disabled');
      }
    });
  }
};


// WEBPACK FOOTER //
// ./src/app/components/c-checkout-payment-card/checkout-payment-card.js